import React from 'react'
import { Navigation } from './NavNavigation/Navigation'

export const Navbar = () => {
    return (
        <div className="sm:hidden md:hidden lg:flex justify-between h-18 my-12 ml-10">
            <img className="w-12 h-12 mt-6" src="./assets/shared/logo.svg" alt="logo" />
            <section className="flex justify-between w-8/12 bg-clear">
                <Navigation />
            </section>
        </div>
    )
}
